import type { ReadonlyRecord } from './Types'

export const nameFunction = <F extends (...args: any) => any, N extends string>(func: F, functionName: N): F => {
    const aux = { [functionName]: (...args: any) => func(...args) } as ReadonlyRecord<N, F>
    return aux[functionName]
}
